<template>
    <router-link class="i-con-h-a" :to="{name: target, params: params}">
        <i class="i-con"
            :class="{'i-con-edit': !viewLink, 'i-con-eye': viewLink}">

    </i></router-link>
</template>

<script>
    export default {
        name: "TableEditLink",

        props: {
            target: {
                type: String,
                required: true
            },
            params: {
                type: Object,
                required: false
            },
            viewLink: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>